/* eslint-disable */
/**
 * JSP 단에서 TMON.webpackPublicPath 설정 필수
 * ex) localscript.jsp 내에서
 * TMON.webpackPublicPath = '<web:staticResource serviceId="서비스아이디" serviceIdDirectory="true" />/';
 * !!마지막 / 필수
 * 
 * HMR 적용시 entry point의 시작점에 넣기 바랍니다.
 * if(module.hot) module.hot.accept();
 */
__webpack_public_path__ = window.TMON.webpackPublicPath;
